import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import "../styles/main.scss";
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#46b98c",
        secondary: "#36393a",
        accent: "#46b98c",
      },
    },
  },
});
